import {
  fetchAllMentorClassGroupMeetings,
  fetchMentorClassGroupMeeting,
} from "classroom/api/teacher";
import type { GroupMeeting } from "meetings/group-meeting/types";
import { defineStore } from "pinia";

export const useClassroomMentorClassGroupMeetingStore = defineStore(
  "classroomMentorClassGroupMeeting",
  () => {
    const loadGroupMeeting = async (
      mentorClass: string,
      signal?: AbortSignal,
    ): Promise<GroupMeeting> => {
      return fetchMentorClassGroupMeeting(mentorClass, signal);
    };

    const loadAllGroupMeetings = async (
      signal?: AbortSignal,
    ): Promise<GroupMeeting[]> => {
      return fetchAllMentorClassGroupMeetings(signal);
    };

    return { loadGroupMeeting, loadAllGroupMeetings };
  },
);
